(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire409a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire409a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dYQct", function(module, exports) {

var $g6gZY = parcelRequire("g6gZY");
//
// ==UserScript==
// @name Show Whitespace
// @description Displays whitespace characters in code blocks when alt+shift+w is pressed.
// @namespace https://userscripts.kevincox.ca
// @version 1
// @grant none
// @include *
// ==/UserScript==
(0, $g6gZY.default)("alt+W", (_event)=>{
    var selectors = "pre";
    if (location.hostname == "github.com") selectors += ",.cm,.blob-code";
    [
        ...document.querySelectorAll(selectors)
    ].forEach(function process(el) {
        if (el.nodeName != "#text") {
            [
                ...el.childNodes
            ].forEach(process);
            return;
        }
        var highlight = el.ownerDocument.createElement("span");
        highlight.textContent = el.textContent;
        let escaped = highlight.innerHTML;
        let highlighted = escaped.replace(/ +/g, '<span style="background:hsla(  0, 50%, 50%, 0.3)">$&</span>').replace(/\t+/g, '<span style="background:hsla(240, 50%, 50%, 0.4)">$&</span>');
        if (highlighted != escaped) {
            highlight.innerHTML = highlighted;
            el.parentNode?.replaceChild(highlight, el);
        }
    });
});

});
parcelRegister("g6gZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a158e299d78a613b$export$2e2bcd8739ae039);
function $a158e299d78a613b$export$2e2bcd8739ae039(keybind, func) {
    document.addEventListener("keydown", (e)=>{
        let modifiers = keybind.split("+");
        let key = modifiers.pop();
        if (key != e.key) return;
        for (let modifier of modifiers){
            if (!e[`${modifier}Key`]) return;
        }
        e.preventDefault();
        return func(e);
    });
}

});



parcelRequire("dYQct");
})();
//# sourceMappingURL=show-whitespace.user.js.map
